module.exports = __webpack_public_path__ + "img/Doc16a1_20070019-001_18-Aug-1915_1.218fb70a.jpg";